<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-tigrinja');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u1200 \u1201 \u1202 \u1203 \u1204 \u1205 \u1206',
                    '\u1208 \u1209 \u120a \u120b \u120c \u120d \u120e \u120f',
                    '\u1210 \u1211 \u1212 \u1213 \u1214 \u1215 \u1216 \u1217',
                    '\u1218 \u1219 \u121a \u121b \u121c \u121d \u121e \u121f',
                    '\u1228 \u1229 \u122a \u122b \u122c \u122d \u122e \u122f',
                    '\u1230 \u1231 \u1232 \u1233 \u1234 \u1235 \u1236 \u1237',
                    '\u1238 \u1239 \u123a \u123b \u123c \u123d \u123e \u123f',
                    '\u1240 \u1241 \u1242 \u1243 \u1244 \u1245 \u1246 \u1247',
                    '\u1250 \u1251 \u1252 \u1253 \u1254 \u1255 \u1256',
                    '\u1260 \u1261 \u1262 \u1263 \u1264 \u1265 \u1266 \u1267',
                    '\u1268 \u1269 \u126a \u126b \u126c \u126d \u126e \u126f',
                    '\u1270 \u1271 \u1272 \u1273 \u1274 \u1275 \u1276 \u1277',
                    '\u1278 \u1279 \u127a \u127b \u127c \u127d \u127e \u127f',
                    '\u1290 \u1291 \u1292 \u1293 \u1294 \u1295 \u1296 \u1297',
                    '\u1298 \u1299 \u129a \u129b \u129c \u129d \u129e \u129f',
                    '\u12a0 \u12a1 \u12a2 \u12a3 \u12a4 \u12a5 \u12a6 \u12a7',
                    '',
                    '\u12a8 \u12a9 \u12aa \u12ab \u12ac \u12ad \u12ae \u12af',
                    '\u12b8 \u12b9 \u12ba \u12bb \u12bc \u12bd \u12be',
                    '\u12c8 \u12c9 \u12ca \u12cb \u12cc \u12cd \u12ce',
                    '\u12d0 \u12d1 \u12d2 \u12d3 \u12d4 \u12d5 \u12d6',
                    '\u12d8 \u12d9 \u12da \u12db \u12dc \u12dd \u12de \u12df',
                    '\u12e0 \u12e1 \u12e2 \u12e3 \u12e4 \u12e5 \u12e6 \u12e7',
                    '\u12e8 \u12e9 \u12ea \u12eb \u12ec \u12ed \u12ee',
                    '\u12f0 \u12f1 \u12f2 \u12f3 \u12f4 \u12f5 \u12f6 \u12f7',
                    '\u1300 \u1301 \u1302 \u1303 \u1304 \u1305 \u1306 \u1307',
                    '\u1308 \u1309 \u130a \u130b \u130c \u130d \u130e \u130f',
                    '\u1320 \u1321 \u1322 \u1323 \u1324 \u1325 \u1326 \u1327',
                    '\u1328 \u1329 \u132a \u132b \u132c \u132d \u132e \u132f',
                    '\u1330 \u1331 \u1332 \u1333 \u1334 \u1335 \u1336 \u1337',
                    '\u1338 \u1339 \u133a \u133b \u133c \u133d \u133e \u133f',
                    '\u1348 \u1349 \u134a \u134b \u134c \u134d \u134e \u134f',
                    '\u1350 \u1351 \u1352 \u1353 \u1354 \u1355 \u1356 \u1357',
                    '',
                    '\u1248 \u124a \u124b \u124c \u124d',
                    '\u1258 \u125a \u125b \u125c \u125d',
                    '\u12b0 \u12b2 \u12b3 \u12b4 \u12b5',
                    '\u12c0 \u12c2 \u12c3 \u12c4 \u12c5',
                    '\u1310 \u1312 \u1313 \u1314 \u1315',
                    '',
                    '\u1362 \u1363 \u2026',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
